import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { EmailRecipient } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service to get and save emailRecipient data.
 */
@Injectable()
export class EmailRecipientService {
    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Add or update the emailRecipient
     */
    public save(
        eventId: string,
        emailMessageId: string,
        emailRecipient: EmailRecipient,
        includes: string[] = null,
    ): Observable<EmailRecipient> {
        let response: Observable<IJsonApiResponse>;
        const apiRequestUrl: string = this.getApiUrl(eventId, emailMessageId, emailRecipient.id, includes);

        if (emailRecipient.id) {
            // Update existing EmailRecipient
            response = this.http.patch(apiRequestUrl, emailRecipient.serialize());
        } else {
            // Add a new EmailRecipient
            response = this.http.post(apiRequestUrl, emailRecipient.serialize());
        }

        return response.pipe(map((response: IJsonApiResponse) => (new EmailRecipient()).deserialize(response)));
    }

    /**
     * Delete the specified emailRecipient.
     */
    public delete(eventId: string, emailMessageId: string, emailRecipientId: string): Observable<boolean> {
        const apiRequestUrl: string = this.getApiUrl(eventId, emailMessageId, emailRecipientId);
        return this.http.delete(apiRequestUrl).pipe(map((response: IJsonApiResponse) => true));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(
        eventId: string,
        emailMessageId: string,
        emailRecipientId?: string,
        includes?: string[],
        queryParams: string[] = null,
    ): string {
        let url: string =
            `${this.http.configService.getApiBaseUrl()}/events/${eventId}/emails/${emailMessageId}/to-recipients/`;

        if (emailRecipientId) {
            url += emailRecipientId;
        }

        url += this.http.getQueryParameters(includes, queryParams);

        return url;
    }
}
